import { Alert } from '@ksyos/design-system';
import type { ConclusieDiagnoseOption } from '../../../../../../common/enums/conclusieDiagnoseOption';
import type { ValidationErrors } from '../../../../../utils/validation';
import {
    Policies,
    TfcV1DiagnosticReportBezoekAanSpecialist,
    urgenciesAccordingToGuideline,
    urgenciesForReferral,
} from '../../../../../../common/validation/customControls/ophthalmology';
import { DropdownField } from '../../../../fields/Dropdown';
import { TextAreaField } from '../../../../fields/TextArea';

export interface ICustomControlData {
    bezoek_aan_specialist_nu_nodig?: TfcV1DiagnosticReportBezoekAanSpecialist;
    conclusie_diagnose?: ConclusieDiagnoseOption;
    geadviseerd_beleid: string | null;
    geadviseerd_beleid_anders: string | null;
    urgentie: string | null;
}

interface IFundusscreeningPolicyAndUrgencyProps {
    advisedPolicies: Policies[];
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (values: Partial<ICustomControlData>) => Promise<void>;
    requiredPolicy?: boolean;
}

export function OldFundusscreeningPolicyAndUrgencyAddEditFields(props: IFundusscreeningPolicyAndUrgencyProps) {
    return (
        <>
            <DropdownField
                automation="measures"
                error={props.errors.get('customControlData.geadviseerd_beleid')}
                fieldKey="geadviseerd_beleid"
                hasErrors={
                    props.errors.has('customControlData.geadviseerd_beleid') ||
                    props.errors.has('customControlData.geadviseerd_beleid_anders')
                }
                isRequired={
                    props.requiredPolicy ||
                    props.customControlData.bezoek_aan_specialist_nu_nodig ===
                        TfcV1DiagnosticReportBezoekAanSpecialist.zieBeleid
                }
                label="Geadviseerd beleid"
                onChange={(value) => {
                    props.handleChangeCustomControl({
                        geadviseerd_beleid: value,
                        geadviseerd_beleid_anders: null,
                        urgentie: null,
                    });
                }}
                placeholder="Kies uit de lijst"
                selectOptions={getAdvisedPolicyOptions(props.advisedPolicies)}
                value={props.customControlData.geadviseerd_beleid}
            />

            {[
                Policies.controleVolgensRichtlijn,
                Policies.verwijzingOogartsDoorHuisarts,
                Policies.verwijzingOogartsDoorOptometrist,
            ].includes(props.customControlData.geadviseerd_beleid as Policies) && (
                <DropdownField
                    automation="urgency"
                    error={props.errors.get('customControlData.urgentie')}
                    fieldKey="urgentie"
                    hasErrors={props.errors.has('customControlData.urgentie')}
                    isRequired
                    label="Urgentie"
                    placeholder="Kies uit de lijst"
                    selectOptions={urgencyOptions(props.customControlData)}
                />
            )}

            {props.customControlData.geadviseerd_beleid === Policies.anders && (
                <TextAreaField
                    error={props.errors.get('customControlData.geadviseerd_beleid_anders')}
                    fieldKey="geadviseerd_beleid_anders"
                    hasErrors={props.errors.has('customControlData.geadviseerd_beleid_anders')}
                    label=" "
                    placeholder={'Beschrijf beleid'}
                />
            )}
            {(props.customControlData.urgentie === 'Binnen 1 week bij oogarts' ||
                props.customControlData.urgentie === 'Binnen 1 dag bij oogarts') && (
                <Alert appearance="info">
                    Let op: handel de verwijzing direct af. Verwijs de patiënt zelf naar de oogarts of bel de huisarts
                    voor een verwijzing. Indien dit niet mogelijk is, informeer Ksyos (020-6000060).
                </Alert>
            )}
        </>
    );
}

function getAdvisedPolicyOptions(advisedPolicies: Policies[]) {
    return advisedPolicies.map((option) => {
        return { value: option, text: option };
    });
}

function urgencyOptions(customControlData: ICustomControlData) {
    if (customControlData.geadviseerd_beleid === Policies.controleVolgensRichtlijn) {
        return urgenciesAccordingToGuideline.map((policy) => {
            return { value: policy, text: policy };
        });
    } else if (
        [Policies.verwijzingOogartsDoorHuisarts, Policies.verwijzingOogartsDoorOptometrist].includes(
            customControlData.geadviseerd_beleid as Policies
        )
    ) {
        return urgenciesForReferral.map((policy) => {
            return { value: policy, text: policy };
        });
    } else {
        return [{ value: '', text: '' }];
    }
}
